import { render, staticRenderFns } from "./CheckboxCard.vue?vue&type=template&id=33940a9e&"
import script from "./CheckboxCard.vue?vue&type=script&lang=js&"
export * from "./CheckboxCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports